import {
    computed,
    Directive,
    input,
    linkedSignal,
    output,
} from '@angular/core';

@Directive({
    selector: '[qpxDnd]',
    host: {
        '(dragenter)': 'onDragEnter($event)',
        '(dragover)': 'onDragOver($event)',
        '(dragleave)': 'onDragLeave($event)',
        '(drop)': 'onDrop($event)',
        '(window:dragend)': 'clear()',
        '(window:blur)': 'clear()',
        '(window:keydown.escape)': 'clear()',
        '(document:drop)': 'clear()',
        '[attr.aria-disabled]': 'disabled()',
    },
    exportAs: 'qpxDnd',
})
export class Dnd {
    public readonly disabled = input(false);
    public readonly dropped = output<DragEvent>();

    private readonly hover = linkedSignal(() => {
        this.disabled();
        return false;
    });
    private dragDepth = 0;
    public readonly fileOver = computed(() => this.hover() && !this.disabled());

    protected onDragEnter(event: DragEvent): void {
        if (!this.isFileDrag(event)) return;
        this.dragDepth += 1;
        this.onDragOver(event);
    }

    protected onDragOver(event: DragEvent): void {
        if (!this.isFileDrag(event)) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = this.disabled() ? 'none' : 'copy';
        }
        if (this.disabled()) {
            this.clear();
            return;
        }
        this.hover.set(true);
    }

    protected onDragLeave(event: DragEvent): void {
        this.dragDepth = Math.max(0, this.dragDepth - 1);
        if (
            event.currentTarget instanceof Node &&
            event.relatedTarget instanceof Node &&
            event.currentTarget.contains(event.relatedTarget)
        ) {
            return;
        }
        if (this.dragDepth > 0 && !event.relatedTarget) return;
        this.clear();
    }

    protected onDrop(event: DragEvent): void {
        this.clear();
        if (!this.isFileDrag(event)) return;
        event.preventDefault();
        event.stopPropagation();
        if (this.disabled()) return;
        this.dropped.emit(event);
    }

    protected clear(): void {
        this.dragDepth = 0;
        this.hover.set(false);
    }

    private isFileDrag(event: DragEvent): boolean {
        return (
            Array.from(event.dataTransfer?.types ?? []).includes('Files') ||
            Array.from(event.dataTransfer?.items ?? []).some(
                (item) => item.kind === 'file'
            )
        );
    }
}
